module.exports = __webpack_public_path__ + "assets/img/illustration_1.eae12733.png";